export enum TextComparison {
    Equals = 0,
    NonEquals = 1,
    Contains = 2,
    StartsWith = 3,
    EndsWith = 4,
    IsNullOrEmpty = 5
}
